import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 20h6","key":"svg-0"}],["path",{"d":"M12 20v-8","key":"svg-1"}],["path",{"d":"M5 12h14l-4 -8h-6l-4 8","key":"svg-2"}]]

/**
 * IconLamp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGFtcCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOSAyMGg2IiAvPgogIDxwYXRoIGQ9Ik0xMiAyMHYtOCIgLz4KICA8cGF0aCBkPSJNNSAxMmgxNGwtNCAtOGgtNmwtNCA4IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/lamp
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLamp = createReactComponent('outline', 'lamp', 'Lamp', __iconNode);

export default IconLamp;